import React, { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import moment from 'moment-timezone';
import { user } from '../../../redux/user';
import BaseModal from '../BaseModal/BaseModal';

import './MarkAsCallbackModal.scss';

const MarkAsCallbackModal = ({ shiftToMarkAsCallback, isDailyFeed, onConfirm, onClose }) => {
	const { shift, slot } = shiftToMarkAsCallback;
	const userData = useSelector(user, shallowEqual);

	const shiftType = useMemo(() => {
		if (isDailyFeed) {
			return shift.resource_type;
		}
		return shift.shift_specialty
			? `${shift.shift_resource_type}-${shift.shift_specialty}`
			: `${shift.shift_resource_type}`;
	}, [shift, isDailyFeed]);

	const unitName = useMemo(() => {
		if (isDailyFeed) {
			return userData.activeFacility.units.find((u) => u.id === slot.unit_id)?.unit_name || '-';
		}
		return slot.unit_name || '-';
	}, [slot, isDailyFeed, userData.activeFacility.units]);

	return (
		<BaseModal
			confirmNewModal
			title="Mark professional as Called Back?"
			className="mark-as-callback-modal"
			primaryActionLabel="Mark as Called Back"
			onPrimaryAction={onConfirm}
			secondaryActionLabel="Cancel"
			onSecondaryAction={onClose}
			onHide={onClose}
			confirmModalSize="lg"
		>
			<div className="mark-as-callback-modal__container">
				<div className="mark-as-callback-modal__subtitle">
					Once <span>{slot.caregiver_name}</span> is marked as Called Back, they can clock in for their Callback shift.
					Please ensure you have contacted this professional to let them know that they will be needed before
					continuing.
				</div>
				<div>
					<div className="route-slot-modal__column">
						Facility:<span> {shift.facility_name}</span>
					</div>
					<div className="route-slot-modal__column">
						Date:<span> {moment(shift.start_time).tz(shift.facility_timezone).format('dddd[,] MMMM Do YYYY')}</span>
					</div>
					<div className="route-slot-modal__column">
						Time:<span> {`${shift.formatted_start_time} - ${shift.formatted_end_time}`}</span>
					</div>
					<div className="route-slot-modal__column">
						Shift Type:
						<span> {shiftType}</span>
					</div>
					<div className="route-slot-modal__column">
						Unit:
						<span> {unitName}</span>
					</div>
				</div>
			</div>
		</BaseModal>
	);
};

export default MarkAsCallbackModal;
